import { jsx as o } from "react/jsx-runtime";
import { getNameInitials as s } from "../../../utils/text.es.js";
import { chakra as e } from "@chakra-ui/react";
import { useAvatarStyle as a } from "../Avatar.context.es.js";
import { PersonIcon as n } from "../../../icons/index.es.js";
const d = ({ name: i, trackId: r }) => {
  const t = a();
  if (i) {
    const m = s(i);
    return /* @__PURE__ */ o(e.div, { __css: t.emptyName, "track-id": r ? `${r}-error` : void 0, children: m });
  }
  return /* @__PURE__ */ o(e.div, { __css: t.emptyImage, "track-id": r ? `${r}-error` : void 0, children: /* @__PURE__ */ o(n, {}) });
};
export {
  d as AvatarName
};
//# sourceMappingURL=AvatarName.es.js.map
